export default __webpack_public_path__ + "static/PromptIconOne-0be5d7f1be0e7ee224a6d49bcc87a60f.png";